import { sagaEffects } from '../../dependencies';

import submitForm from './submitForm';

const { all } = sagaEffects;

export default function*() {
    yield all([submitForm()]);
}
